<template>
  <div class="test">
    配送路线轨迹
    <div id="container" style="width:100%; height:500px" />
    <el-row>
      <el-col :span="24" class="rowtext">
        <p><strong>如需获取冷链配送的过程温度，可登录http://query.icoldchain.cn,输入【客户编号】和【发货单号】，可查询、下载或打印.</strong></p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AMap from 'AMap'
import AMapUI from 'AMapUI'
export default {
  name: 'MapGps',
  props: {
    gpslist: {
      type: Array,
      default: function() {
        return [
          [121.7872238159, 30.9458135552],
          [121.7868804932, 30.9497885763],
          [121.8043041229, 30.9676741249],
          [121.7592430115, 30.9851884109],
          [121.7494583130, 30.9795959630]
        ]
      }
    }
  },
  data() {
    return {
      gpsData: []
    }
  },
  created() {
    console.log('ss')
    console.log(this.gpslist)
  },
  mounted() { // created 方法不行
    this.loadmap()
  },
  methods: {
    loadmap() {
      console.log(this.gpsData)
      var _this = this
      var map = new AMap.Map('container', {
        center: [116.397428, 39.90923],
        resizeEnable: true,
        zoom: 10
      })
      AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function() {
        map.addControl(new AMap.ToolBar())
        map.addControl(new AMap.Scale())
      })
      AMapUI.load(['ui/misc/PathSimplifier', 'ui/overlay/SimpleMarker'], function(PathSimplifier, SimpleMarker) {
        if (!PathSimplifier.supportCanvas) {
          alert('当前环境不支持 Canvas！')
          return
        }
        var pathSimplifierIns = new PathSimplifier({
          zIndex: 100,
          // autoSetFitView:false,
          map: map, // 所属的地图实例

          getPath: function(pathData, pathIndex) {
            return pathData.path
          },
          getHoverTitle: function(pathData, pathIndex, pointIndex) {
            if (pointIndex >= 0) {
              // point
              return pathData.name + '，点：' + pointIndex + '/' + pathData.path.length
            }

            return pathData.name + '，点数量' + pathData.path.length
          },
          renderOptions: {

            renderAllPointsIfNumberBelow: 1000 // 绘制路线节点，如不需要可设置为-1
          }
        })

        window.pathSimplifierIns = pathSimplifierIns
        console.log(_this.gpslist)
        // 设置数据
        pathSimplifierIns.setData([{
          name: '路线0',
          path: _this.gpslist
        }])

        // 对第一条线路（即索引 0）创建一个巡航器
        var navg1 = pathSimplifierIns.createPathNavigator(0, {
          loop: true, // 循环播放
          speed: 1000 // 巡航速度，单位千米/小时
        })

        navg1.start()
      })
    }
  }
}
</script>
